import baseStyles from "src/global.module.css";
import styles from "src/features/Event/pages/TopV2/topV2.module.css";
import { useState } from "react";
import BottomNavigationBar from "src/components/layout/BottomNavigationBar/BottomNavigationBar";
import { useAtomValue } from "jotai";
import localStorageManager from "src/utils/localStorageManager";
import TopPageHeader from "../../components/TopPageHeader/TopPageHeader";
import ViewModeToggleButton from "../../components/ViewModeToggleButton/ViewModeToggleButton";
import TopPageEventList from "../../components/TopPageEventList/TopPageEventList";
import TopPageScrollIndicator from "../../components/TopPageScrollIndicator/TopPageScrollIndicator";
import {
    alreadyShowedRecommendedArtistDialogAtom,
} from "../../event.atom";
import RecommendedArtistDialog from "../../components/RecommendedArtistDialog/RecommendedArtistDialog";
import CreateEventButton from "../../components/CreateEventButton/CreateEventButton";
import IncludeCompletedEventToggleButton from "../../components/IncludeCompletedEventToggleButton/IncludeCompletedEventToggleButton";

const TopV2: React.FC = () => {
    const userType = localStorageManager.getItem("userType");

    // 公認Artist紹介用
    const alreadyShowRecommendedArtist = useAtomValue(
        alreadyShowedRecommendedArtistDialogAtom
    );

    const [isOpenRecommendedArtist] = useState(!alreadyShowRecommendedArtist);

    return (
        <>
            <div className={baseStyles.page_container}>
                <div className={baseStyles.mb16}>
                    <TopPageHeader />
                </div>
                <div
                    className={`${baseStyles.mb16} ${styles.buttons_container}`}
                >
                    <IncludeCompletedEventToggleButton />
                    <ViewModeToggleButton />
                </div>

                {/* イベントカードリスト */}
                <TopPageEventList />
                <TopPageScrollIndicator />
                <div className={baseStyles.mb64} />
                {userType === "Artist" && <CreateEventButton />}
                <BottomNavigationBar />
            </div>
            {isOpenRecommendedArtist && <RecommendedArtistDialog />}
        </>
    );
};

export default TopV2;
